import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropVote } from "../waves/drop/SingleWaveDropVote";
import MobileWrapperDialog from "../mobile-wrapper-dialog/MobileWrapperDialog";
interface MobileVotingModalProps {
  readonly drop: ExtendedDrop;
  readonly isOpen: boolean;
  readonly onClose: () => void;
}
const MobileVotingModal: React.FC<MobileVotingModalProps> = t0 => {
  const $ = _c(9);
  const {
    drop,
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = e => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      onClose();
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClose = t1;
  let t2;
  if ($[2] !== drop || $[3] !== onClose) {
    t2 = <div className="tw-pt-2 tw-pb-2 tw-px-4"><SingleWaveDropVote drop={drop} onVoteSuccess={onClose} /></div>;
    $[2] = drop;
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleClose || $[6] !== isOpen || $[7] !== t2) {
    t3 = <MobileWrapperDialog isOpen={isOpen} onClose={handleClose} title="Vote for this artwork">{t2}</MobileWrapperDialog>;
    $[5] = handleClose;
    $[6] = isOpen;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default MobileVotingModal;